import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as _ from 'lodash';

import { GenericFilterParameter } from '../models/generic-comunication-cmp';
import { GenericDataSource } from '../models/generic-data-source';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class FilterStructure{
    name: string;
    object: any;
    value: any;
    itemKey: string;
    filterKey: string;
    type: string;
    op: string;

    constructor(){
        this.name = "";
        this.object = null;
        this.value = null;
        this.itemKey = "";
        this.filterKey = "";
        this.type = "";
        this.op = "";
    }
};

export class GeneralFilterComponent{
    @Input() parametriString: string = "{}";
    @Output() filterBoxGenericEmitter = new EventEmitter();

    protected resetContext: boolean = false;
    protected filterMap: Map<string, FilterStructure> = null;
    protected filterFormGroup: FormGroup;

    protected parametri: GenericFilterParameter = null;
    protected numFiltered: number = null;
    protected dataSource: GenericDataSource;
    protected dataArrayOutput: any[];
    searchField$ = new BehaviorSubject<any>(this.filterMap);

    constructor(){
        this.filterMap = new Map();
    }

    isEmpty(value: any){
        let isEmptyResult = true;
        if(value !== null){
            let type = typeof value;
            switch(type){
                case 'object':
                    isEmptyResult = !(value.length > 0);
                    break;
                case 'string':
                    isEmptyResult = !value.trim();
                    break;
                case 'number':
                    isEmptyResult = !value;
                    break;
                case 'undefined':
                    break;
                default:
                    console.log("type", type);
            }
        }
        return isEmptyResult;
    }

    emptyFilterMap(){
        //console.log("emptyFilterMap", this.filterMap);
        let emptyFilterMapResult = true;
        if(this.filterMap){
            this.filterMap.forEach((filterMap: any, key: string) => {
                let filterValue = null;
                filterValue = filterMap["value"];
                emptyFilterMapResult = emptyFilterMapResult && this.isEmpty(filterValue);
            });
        }
        return emptyFilterMapResult;
    }

    emptyExternCommands(){
        let result = true;
        if(this.parametri && this.parametri.externCommandsArray && this.parametri.externCommandsArray.length){
            result = false;
        }
        //console.log("emptyExternCommands result", result, this.parametri.externCommandsArray, this.parametri.externCommandsArray.length);
        return result;
    }

    callbackExternCommands(dataCommand: any){
        let eventObject = {
            "type": "action",
            "data": dataCommand,
        };
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    idStatoChanged(idStatoAttuale: number){
        let idStatoLocal = (idStatoAttuale) ? idStatoAttuale : null;
        let eventObject = {
            "type": "idStatoSelected",
            "data": idStatoLocal,
        };
        //console.log("FILTER-BOX|idStatoSelected", eventObject);
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    groupByCommand(groupByKey: any, groupByType: any){
        let eventObject = {
            "type": "groupBy",
            "data": {
                key: groupByKey,
                value: groupByType,
            },
        };
        console.log("groupBy", eventObject);
        this.filterBoxGenericEmitter.emit(eventObject);
    }

    updateParametri(){
        //console.log('CHANGE FILTER-BOX PARAMETRISTRING', this.parametriString);
        if(this.parametriString){
            this.parametri = new GenericFilterParameter();
            this.parametri = this.parametri.generateParametriFromString(this.parametriString);
        }
        //console.log('CMP|FILTER-GENERIC - CHANGE FILTER-BOX PARAMETRI', this.parametri);
    }

    find(){
        this.numFiltered = null;
        //console.log('CMP|FILTER-GENERIC - FIND', this.parametri, this.filterMap);
        if(this.dataSource){
            this.dataSource.loadResults(this.parametri.dataArraySource, this.filterMap);
            this.dataSource.connect(null).subscribe(
                results => {
                    this.dataArrayOutput = results;
                    if(this.dataArrayOutput){
                        this.numFiltered = this.dataArrayOutput.length;
                        let eventObject = {
                            "type": "filterResult",
                            "filterMap": this.filterMap,
                            "data": this.dataArrayOutput
                        };
                        //console.log('CMP|FILTER-GENERIC - eventObject', eventObject);
                        this.filterBoxGenericEmitter.emit(eventObject);
                    }
                }
            );
        }
    }

    resetFilterMap(){
        if(!this.filterMap){
            this.filterMap = new Map();
        }
    }

    getFilterMap(){
        return this.filterMap;
    }

    getResetContext(){
        return this.resetContext;
    }

    setFilterStructure(keyValue: string, filterStructureValue: any){
        let filterStructureLocal: FilterStructure = new FilterStructure();
        Object.keys(filterStructureLocal).forEach((key) => {
            if(filterStructureValue[key]){
                filterStructureLocal[key] = filterStructureValue[key];
            }
        });
        this.filterMap.set(keyValue, filterStructureLocal);
    }

    setResetContext(resetContext: boolean){
        this.resetContext = resetContext;
    }
}
